"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyTreeContent = void 0;
const react_1 = __importStar(require("react"));
const use_tree_node_filtering_hook_1 = require("../hooks/use-tree-node-filtering.hook");
const strategy_tree_utils_1 = require("../strategy-tree.utils");
const tree_item_1 = require("../tree-item");
const hooks_1 = require("../../../hooks");
const store_1 = require("../../../../store");
const StrategyTreeContent = ({ treeData, productTreeRootNodeId, selectedCategories, allowedL1Ids, allowedNodeIds, hasAttributeFilter, actionsEnabled, onAction, }) => {
    const { checkIsNodeChanged } = (0, hooks_1.useStrategyNodeChanges)();
    const { shouldShowNodeInTree } = (0, use_tree_node_filtering_hook_1.useTreeNodeFiltering)();
    const renderedChildren = (0, react_1.useMemo)(() => {
        var _a;
        if (!((_a = treeData === null || treeData === void 0 ? void 0 : treeData.productTreeNode) === null || _a === void 0 ? void 0 : _a.children))
            return null;
        return treeData.productTreeNode.children.reduce((acc, child) => {
            const { id, productPresentationsNew } = child;
            const childPath = `${productTreeRootNodeId}${store_1.STRATEGY_NODE_PATH_SEPARATOR}${id}`;
            if (hasAttributeFilter && allowedL1Ids && !allowedL1Ids.includes(id))
                return acc;
            if (!hasAttributeFilter && (allowedL1Ids === null || allowedL1Ids === void 0 ? void 0 : allowedL1Ids.length) && !allowedL1Ids.includes(id))
                return acc;
            const hasManuallySelectedNodes = selectedCategories && selectedCategories.length > 0;
            if (!hasManuallySelectedNodes) {
                const shouldShowNode = shouldShowNodeInTree(id, {
                    isChanged: checkIsNodeChanged(childPath),
                    hasContent: productPresentationsNew === null || productPresentationsNew === void 0 ? void 0 : productPresentationsNew.totalCount,
                    hasManualSelection: hasManuallySelectedNodes,
                    ignoreManualVisibility: hasAttributeFilter,
                });
                if (!shouldShowNode)
                    return acc;
            }
            const l1AllowedNodeIds = (0, strategy_tree_utils_1.calculateL1AllowedNodeIds)(id, selectedCategories, allowedNodeIds);
            const handleAction = (event, treeItemNode) => {
                event.stopPropagation();
                onAction(event.target, treeItemNode);
            };
            acc.push(react_1.default.createElement(tree_item_1.StrategyTreeItem, { key: childPath, treeNode: child, parentPath: productTreeRootNodeId, isNodeChanged: checkIsNodeChanged(childPath), allowedNodeIds: l1AllowedNodeIds, hasAttributeFilter: hasAttributeFilter, actionsEnabled: actionsEnabled, onAction: handleAction }));
            return acc;
        }, []);
    }, [
        treeData,
        productTreeRootNodeId,
        allowedL1Ids,
        allowedNodeIds,
        hasAttributeFilter,
        checkIsNodeChanged,
        shouldShowNodeInTree,
        selectedCategories,
        actionsEnabled,
        onAction,
    ]);
    return react_1.default.createElement(react_1.default.Fragment, null, renderedChildren);
};
exports.StrategyTreeContent = StrategyTreeContent;
exports.default = exports.StrategyTreeContent;
